import React from "react";
import nextId from "react-id-generator";
import { Link, useHistory } from "react-router-dom";
import { updateCandidateEmployment } from "../../../../APIs/PostAPIS";
import CustomCheckBox from "../../../Common/CustomCheckbox/CustomCheckBox";
import { MainContext } from "../../../Dashboard/DashboardContext/Context";
import Notification from "../../../Portals/Notification/Notification";
import "./employment.style.scss";
import EmploymentForm from "./EmploymentForm";
export default function EmploymentComponent({
  changeRoute,
  currentRoute,
  setNotification,
  notification,
  completeIt
}) {
  const context = React.useContext(MainContext);
  const { userDetails, initialChecking, updateState, registrationStep } =
    context;
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [employmentData, setEmploymentData] = React.useState({
    candidate_fresher: true,
    candidate_employment: [],
    candidate_total_experience: "",
    candidate_skill: [],
  });
  const handleChanges = (obj, num) => {
    employmentData.candidate_employment[num] = { ...obj };
    setEmploymentData({
      ...employmentData,
      candidate_employment: [...employmentData.candidate_employment],
    });
  };
  const handleSkip = () => {
    let temp = [...registrationStep];
    temp[2] = { ...temp[2], skipped: true };
    updateState("registrationStep", [...temp]);
    changeRoute();
    history.push("/register/preferences");
  };
  const handleDelete = (num) => {
    employmentData.candidate_employment.splice(num, 1);
    setEmploymentData({
      ...employmentData,
      candidate_employment: [...employmentData.candidate_employment],
    });
  };
  const handleSkills = (skill) => {
    let temp = employmentData.candidate_skill.filter((x) => {
      return skill !== x;
    });
    setEmploymentData({ ...employmentData, candidate_skill: [...temp] });
  };
  const handleChange = (obj) => {
    if (obj.id) {
      setEmploymentData({
        candidate_fresher: true,
        candidate_employment: [],
        candidate_skill: employmentData.candidate_skill,
        candidate_total_experience: "",
      });
    } else {
      setEmploymentData({
        candidate_fresher: false,
        candidate_employment: [schema],
        candidate_skill: employmentData.candidate_skill,
        candidate_total_experience: "",
      });
    }
    // setType(obj);
  };

  const clearNotification = () => {
    history.push("/register/preferences");
    let a = setTimeout(() => {
      setNotification({
        status: false,
        title: "",
        moreDetails: "",
      });
      changeRoute();
      setLoading(false);
      clearTimeout(a);
    }, [3000]);
  };
  const handleUpdate = async () => {
    setLoading(true);
    try {
      let res = await updateCandidateEmployment({ ...employmentData });
      if (!res.data.error) {
        completeIt()
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: ``,
        });
        initialChecking();
        clearNotification();
      } else {
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const validations = () => {
    if (employmentData.candidate_fresher) {
      let check = !employmentData.candidate_skill.length;

      setError(check);
      return check;
    } else {
      let temp =
        employmentData.candidate_employment[
          employmentData.candidate_employment.length - 1
        ];
      let check =
        !employmentData.candidate_total_experience ||
        !employmentData.candidate_skill.length ||
        !temp.institute_name ||
        !temp.curriculum ||
        !temp.designation ||
        !temp.class ||
        !temp.worked_from.month ||
        !temp.worked_from.year ||
        (!temp.worked_till.month && !temp.currently_working) ||
        (!temp.worked_till.year && !temp.currently_working);
      setError(check);
      return check;
    }
  };

  React.useEffect(() => {
    currentRoute();
  }, []);
  React.useEffect(() => {
    let temp = {
      candidate_fresher:
        userDetails.candidate_fresher === undefined ||
        userDetails.candidate_fresher
          ? true
          : false,
      candidate_employment: userDetails.candidate_employment || [],
      candidate_total_experience: userDetails.candidate_total_experience,
      candidate_skill: userDetails.candidate_skill,
    };
    setEmploymentData({ ...temp });
  }, [userDetails]);
  return (
    <div className="employment-component-main">
      <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
      <header className="ec-header">
        <p>Step 3. Employment</p>
      </header>
      <div className="ec-body">
        <div className="ec-decider">
          <CustomCheckBox
            handleChange={(obj) => handleChange(obj)}
            selected={employmentData.candidate_fresher}
            list={typeList}
            title=""
          />
        </div>
        {!employmentData.candidate_fresher &&
          employmentData.candidate_employment.map((obj, num) => (
            <EmploymentForm
              error={error}
              current={num === employmentData.candidate_employment.length - 1}
              handleChanges={handleChanges}
              employmentData={employmentData}
              num={num}
              data={obj}
              setEmploymentData={setEmploymentData}
              handleDelete={handleDelete}
            />
          ))}

        <div
          style={employmentData.candidate_fresher ? { display: "none" } : {}}
          className="add-more-section"
        >
          <p
            onClick={() =>
              validations()
                ? console.log()
                : setEmploymentData({
                    ...employmentData,
                    candidate_employment: [
                      ...employmentData.candidate_employment,
                      schema,
                    ],
                  })
            }
          >
            + Add Employment
          </p>
        </div>
        <div className="skills-wrapper">
          <div
            style={employmentData.candidate_fresher ? { display: "none" } : {}}
            className={`fancy-input ${
              error && !employmentData.candidate_total_experience ? "error" : ""
            }`}
          >
            <span>Total Work Experience</span>
            <input
              onChange={(e) =>
                setEmploymentData({
                  ...employmentData,
                  candidate_total_experience: e.target.value,
                })
              }
              type="number"
              value={employmentData.candidate_total_experience}
              placeholder="Total Experience"
            />
          </div>
          <div
            className={`skills-list ${
              error && !employmentData.candidate_skill.length
                ? "error-skills"
                : ""
            }`}
          >
            <span className="sl-title">Mention Skills*</span>
            {employmentData.candidate_skill &&
              employmentData.candidate_skill.map((obj) => (
                <button>
                  {obj} <span onClick={() => handleSkills(obj)}>x</span>
                </button>
              ))}

            <input
              onKeyPress={(e) => {
                if (e.which === 13 || e.which === 32) {
                  setEmploymentData({
                    ...employmentData,
                    candidate_skill: [
                      ...employmentData.candidate_skill,
                      e.target.value,
                    ],
                  });
                  e.target.value = "";
                }
              }}
              autoFocus
              placeholder="+ Add SKill"
            />
          </div>
        </div>
      </div>
      <div className="ec-footer">
        <button onClick={() => handleSkip()} to="/register/preferences">
          Skip Step
        </button>
        <button
          disabled={loading}
          onClick={() => (validations() ? console.log() : handleUpdate())}
        >
          {loading ? "Updating...." : "Update"}
        </button>
      </div>
    </div>
  );
}
const schema = {
  institute_name: "",
  curriculum: "",
  designation: "",
  class: "",
  worked_from: { month: "", year: "" },
  worked_till: { month: "", year: "" },
  currently_working: true,
  stillWorking: true,
};

const typeList = [
  { keyId: nextId(), name: "I’m a fresher", id: true },
  { keyId: nextId(), name: "I’m Experienced", id: false },
];
